import React from "react";
import {
  ReusableOnboardingMapButton,
  ReusableOnboardingButton,
} from "../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import SuggestNewButton from "../../../reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import isEmpty from "../../../../../store/validation/is-Empty";
import Switch from "react-switch";
import { useHistory } from "react-router";

export const HealthAndSenitationOthersFour = ({
  servicesCheck,
  servicesCheckHandler,
  bigText,
  smallText,
  primaryBigText,
  primarySmallText,
  otherHealth,
  selectedOtherHealth,
  primaryOtherHealth,
  onRestaurantSelectorArraySelector,
  onRestaurantsPrimarySelector,
  removeButton,
  onBackButtonFourClick,
  onNextButtonFourClick,
  displayNextButton,
  protocolNext,
  actionButton,
}) => {
  const history = useHistory();
  return (
    <React.Fragment>
      <div className="col-12">
        <div className="row health_and_senitation_onboarding_main_div">
          <div className="col-9 col-sm-9 col-md-10 col-lg-10 col-xl-10 pl-0 health_and_senitation_onboarding_main_divone">
            <div className="f16-700 mt-4 pb-2">
              Do you follow Health and Sanitation practices for Services and
              Handling process?
            </div>
            <div className="f11-400 opacity5">
              Turn off this section if doesn’t applicable to your Business
            </div>
          </div>
          <div className="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2 p-0 health_and_senitation_onboarding_main_divtwo mt-4">
            <Switch
              checked={servicesCheck}
              onChange={servicesCheckHandler}
              offColor="#EEEEEE"
              onColor="#EEEEEE"
              offHandleColor="#212121"
              onHandleColor="#59F832"
              handleDiameter={22}
              uncheckedIcon={false}
              checkedIcon={false}
              height={14}
              width={38}
              boxShadow="-2px 0px 5px #0000003B"
              activeBoxShadow="-2px 0px 5px #0000003B"
              id="material-switch"
            />
          </div>
        </div>
      </div>
      <div className="restaurant_type_onboarding_main margin-bottom-chains-onboarding">
        {servicesCheck === true ? (
          <div>
            <div className="col-12 located-inside-heading-text">
              <div className="f14-500 mt-4">{bigText}</div>
              {/* {protocolNext === true ? ( */}
              <div className="f11-400 opacity5">{smallText}</div>
              {/* ) : null} */}
            </div>
            <div className="cuisine-main ">
              {/* {protocolNext === true ? ( */}
              <div>
                <div
                  className={
                    otherHealth.length > 8 ? "cuisine-main-padding-border" : ""
                  }
                >
                  <div
                    id="box-style"
                    className="cuisine-main-padding justify-content-start column-2"
                    style={{ display: "flex", flexWrap: "wrap" }}
                  >
                    {otherHealth.map((icon, index) => (
                      <ReusableOnboardingMapButton
                        key={index}
                        classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                        src={icon.icon}
                        title={icon.title}
                        onClick={
                          // protocolNext === true
                            // ? 
                            onRestaurantSelectorArraySelector(icon, index)
                            // : null
                        }
                      />
                    ))}
                  </div>
                </div>
                <div className="suggest-button-heading mt-4">
                  <SuggestNewButton categoryId={"5f562c9094ac7fdf47ea1d13"} />
                </div>
              </div>
              {/* ) : null} */}
              {/** */}
              {!isEmpty(selectedOtherHealth) ? (
                <React.Fragment>
                  <div className="f14-500 mt-4">{primaryBigText}</div>
                  <div className="f11-400 opacity5">{primarySmallText}</div>
                </React.Fragment>
              ) : null}

              <div
                className="cuisine-main-padding-bottom justify-content-start column-2 mt-4"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {selectedOtherHealth.map((icon, index) => (
                  <ReusableOnboardingMapButton
                    key={index}
                    classsection={
                      // icon._id === primaryOtherHealth._id
                      //   ?
                      "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                      // : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                    }
                    extraPrimaryStyles={
                      history.location.pathname.includes("edit")
                        ? {
                            marginBottom: "10px",
                            bottom: "0.5px",
                            position: "relative",
                          }
                        : {}
                    }
                    src={icon.icon}
                    title={icon.title}
                    displayPrimary={
                      icon._id === primaryOtherHealth._id ? true : false
                    }
                    onClick={onRestaurantsPrimarySelector(icon)}
                    displayRemove={true}
                    removeButtonClick={removeButton(icon)}
                  />
                ))}
              </div>
            </div>
          </div>
        ) : null}
        <div className="onboarding-map-setup-screen-autodetect-button">
          {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
            buttonText="Back"
            buttonType="button"
            onClick={onBackButtonFourClick}
          />
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass={`onboarding_button_link_reusable ${
              servicesCheck
                ? errorChecker(selectedOtherHealth, primaryOtherHealth)
                : servicesCheck
                ? "onboarding_button_link_reusable_gray ml-3"
                : "onboarding_button_link_reusable_red ml-3"
            }`}
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            buttonText={displayNextButton === true ? "Save & Next" : "Next"}
            buttonType="button"
            disabled={
              servicesCheck
                ? errorChecker(selectedOtherHealth, primaryOtherHealth)
                : servicesCheck
            }
            onClick={onNextButtonFourClick}
          />
          {/* </div> */}
        </div>
      </div>
    </React.Fragment>
  );
};

const errorChecker = (selectedOtherHealth, primaryOtherHealth) => {
  if (selectedOtherHealth.length === 0 || isEmpty(primaryOtherHealth)) {
    return true;
  } else {
    return false;
  }
};
